import React, {useLayoutEffect} from 'react'
import HTMLReactParser from 'html-react-parser'
import { Box } from '@mui/material'


// If table is wider than parent, add class to make it sideways scrollable with inside shadow.
const checkTablesFit = (tables) => {
  tables.forEach((table) => {

    const tableRight = table.getBoundingClientRect().right;
    const parentRight = table.parentElement.getBoundingClientRect().right;

    if (tableRight > parentRight) {
      table.classList.add('table-overflow');
    } else {
      // Removing class here would cause flickering/unexpected behavior, since a table with 'table-overflow' has different width.
      // The simplest solution is therefore to keep the class, resulting in some right-side-shadow that
      // is not required when resizing, but still makes the content visible, so only a minor visual problem.
      // table.classList.remove('table-overflow');
    }
  });
};

const Content = ({data}) => {
  useLayoutEffect(() => {
    const handleResize = () => {
      const parentElement = document.querySelector('.page-node-type-online-edition-page');
      const tables = parentElement.querySelectorAll('table');
      checkTablesFit(tables);
    };

    window.addEventListener('resize', handleResize);

    // Make sure it checks on first load, also on Safari
    window.onload = handleResize;

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [data.page_content]);

  return (
    <>
      <Box>{HTMLReactParser(data.page_content)}</Box>
    </>
  )
}

export default Content
